export interface IFollowUpSurveyShow {
    show6Month: boolean,
    show12Month: boolean,
    show24Month: boolean,
    showOtherMonths: boolean
}